<template>
  <div id="map_container" style="width: 100%; height: 100%">

  </div>
</template>
<script>
import request from '@/utils/apiRequest'
import defaultDangerRecord from './defaultDangerRecord'

export default {
  model: {
    prop: 'currentPointGps',
    event: 'change'
  },
  props: {
    currentPointGps: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      map: {},
      currentMaker: null
    };
  },
  computed: {
  },
  mounted(){
    this.initMap()
  },
  watch: {
    form: {
      handler(newValue, oldValue) {

      },
      deep: true
    }
  },
  methods: {
    // 初始化地图
    initMap() {
      let hasDefaultMarker = true
      if (!this.currentPointGps) {
        this.currentPointGps = '120.478632,36.121562'
        hasDefaultMarker = false
      }

      // 把地图挂载到id为map_container的div上
      this.map = new AMap.Map("map_container", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 16, //初始化地图层级
        zooms: [1, 30],
        center: this.currentPointGps.split(','), //初始化地图中心点,
        doubleClickZoom: false  // 禁用双击放大功能，”双击“留给设置点位功能
      });

      if (hasDefaultMarker) {
        // 添加默认点位
        this.currentMaker = this.addMaker(this.currentPointGps.split(','))
      }
      // 绑定点击事件
      this.clickOn()
    },
    // 地图单击事件
    showInfoClick(e){

    },
    // 地图双击事件
    showInfoDbClick(e){
      this.clearMarker(this.currentMaker)
      this.currentMaker = this.addMaker([e.lnglat.getLng(), e.lnglat.getLat()])
      // 绑定到父元素
      this.$emit('change', '' + e.lnglat.getLng() + ',' + e.lnglat.getLat())
    },
    // 绑定事件
    clickOn(){
      this.map.on('click', this.showInfoClick);
      this.map.on('dblclick', this.showInfoDbClick);
    },
    // 解绑事件
    clickOff(){
      this.map.off('click', showInfoClick);
      this.map.off('dblclick', showInfoDbClick);
      this.map.off('mousemove', showInfoMove);
    },
    // 添加点
    addMaker(position) {
      var marker = new AMap.Marker({
        map: this.map,
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: position
      })
      this.map.add(marker);
      return marker
    },
    // 删除点
    clearMarker(marker) {
      if (marker) {
        marker.setMap(null);
        marker = null;
      }
    }
  }

};
</script>
<style>

</style>
